import React from 'react';

import { DEFAULT_ICON_PROPS, IIconProps } from '../constants';

export const TwitterBlueIcon = ({ ariaLabel = 'Twitter', ...props }: IIconProps) => {
  const { size, width, height, title, ariaHidden, className } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      width={size || width}
      height={size || height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={ariaLabel}
      aria-hidden={ariaHidden}
      className={`block ${className}`}
      {...props}
    >
      {title && <title>{title}</title>}
      <rect width="32" height="32" rx="4" fill="#1B97F0" />
      <path
        d="M25.4128 12.247C25.4266 12.4495 25.4266 12.6521 25.4266 12.8564C25.4266 19.0842 20.7487 26.2667 12.1949 26.2667V26.2629C9.66813 26.2667 7.19381 25.5331 5.06665 24.15C5.43407 24.1948 5.80333 24.2172 6.17351 24.2181C8.26752 24.22 10.3017 23.5079 11.9491 22.1967C9.95911 22.1584 8.21411 20.8434 7.60451 18.9237C8.30159 19.0599 9.01985 19.0319 9.70404 18.8425C7.53452 18.3982 5.97369 16.4663 5.97369 14.2228C5.97369 14.2022 5.97369 14.1826 5.97369 14.163C6.62012 14.5279 7.34391 14.7305 8.08427 14.7529C6.04091 13.3688 5.41105 10.6138 6.64498 8.45979C9.00604 11.4043 12.4896 13.1943 16.2292 13.3837C15.8544 11.7468 16.3664 10.0314 17.5745 8.88069C19.4475 7.09627 22.3933 7.18773 24.154 9.08508C25.1955 8.87696 26.1937 8.48965 27.1071 7.94088C26.76 9.03188 26.0334 9.95862 25.0629 10.5475C25.9846 10.4374 26.8852 10.1873 27.7333 9.80557C27.109 10.7538 26.3226 11.5797 25.4128 12.247Z"
        fill="white"
      />
    </svg>
  );
};
